import {
  Handshake,
  Home,
  ProductionQuantityLimits,
  Web,
  Apartment,
  CalendarToday,
  Group,
  Person,
  RssFeed,
  Subscriptions,
} from "@mui/icons-material";

import { Menu } from "../model/menu";

export const menus: Menu[] = [
  {
    name: "Dashboard",
    path: "/",
    icon: Home,
  },




  {
    name: "User",
    path: "/users",
    icon: Person, // Single user
  },
  {
    name: "Blog",
    path: "/blogs",
    icon: RssFeed, // RSS feed icon fits "blog"
  },
  {
    name: "Testimonial",
    path: "/testimonials",
    icon: RssFeed, // RSS feed icon fits "blog"
  },


  {
    name: "Subscribers",
    path: "/subscribers",
    icon: Subscriptions, // Subscription icon
  },
    {
    name: "Newsletters",
    path: "/newsletters",
    icon: Subscriptions, // Subscription icon
  },
  {
    name: "Messages",
    path: "/messages",
    icon: Subscriptions, // Subscription icon
  },

];
